import { ActorRoles, Link } from '.'
import {
  HEADER_DEMO_LINK,
  HOME_LINK,
  HOST_ADMIN_LINK,
  HOST_LEADS_LINK,
  HOST_SPACES_LINK,
  SMART_BOOK_EVENTS_LINK,
  SMART_BOOK_INSIGHTS_LINK,
  SMART_BOOK_RESPONSE_LINK
} from '../Constants'
import { useGlobalState } from '../Store'

export const subNavLocations: string[] = [
  HEADER_DEMO_LINK,
  HOST_ADMIN_LINK,
  HOST_LEADS_LINK,
  SMART_BOOK_EVENTS_LINK,
  SMART_BOOK_INSIGHTS_LINK,
  SMART_BOOK_RESPONSE_LINK
]

export const adminAMLeads: Link = {
  href: `${HOST_ADMIN_LINK}/am-leads`,
  title: 'AM Leads'
}

export const adminLFLeads: Link = {
  href: `${HOST_ADMIN_LINK}/lf-leads`,
  title: 'LF Leads'
}

export const adminInterestedGuests: Link = {
  href: `${HOST_ADMIN_LINK}/interested-guests`,
  title: 'Interested guests'
}

export const adminHostAccess: Link = {
  href: `${HOST_ADMIN_LINK}/host-access`,
  title: 'Host access'
}

export const adminReviewSpaces: Link = {
  href: `${HOST_SPACES_LINK}/admin`,
  title: 'Review spaces'
}

export const redBoxAdmin: Link = {
  href: `${HOME_LINK}/admin`,
  target: '_blank',
  title: 'RedBox admin'
}

export const leadFeed: Link = {
  href: `${HOST_LEADS_LINK}/leadfeed`,
  title: 'Lead Feed'
}

export const leadFeedInterestedGuests: Link = {
  href: `${HOST_LEADS_LINK}/interestedguests`,
  title: 'Interested guests'
}

export const leadFeedSentMessages: Link = {
  href: `${HOST_LEADS_LINK}/sentmessages`,
  title: 'Sent messages'
}

export const leadFeedInsights: Link = {
  href: `${HOST_LEADS_LINK}/insights`,
  title: 'Insights'
}

export const leadFeedTemplates: Link = {
  href: `${HOST_LEADS_LINK}/templates`,
  title: 'Templates'
}

export const leadFeedPreferences: Link = {
  href: `${HOST_LEADS_LINK}/preferences`,
  title: 'Preferences'
}

export const smartBookResponseOpportunities: Link = {
  href: `${SMART_BOOK_RESPONSE_LINK}/opportunities`,
  title: 'Opportunities'
}

export const smartBookResponseBookings: Link = {
  href: `${SMART_BOOK_RESPONSE_LINK}/bookings`,
  title: 'Bookings'
}

export const smartBookResponseArchive: Link = {
  href: `${SMART_BOOK_RESPONSE_LINK}/archive`,
  title: 'Archive'
}

export const smartBookEvents: Link = {
  href: SMART_BOOK_EVENTS_LINK,
  title: 'My events'
}

export const smartBookInsights: Link = {
  href: SMART_BOOK_INSIGHTS_LINK,
  title: 'Insights'
}

export const adminSubNav: Link[] = [
  adminAMLeads,
  adminLFLeads,
  adminInterestedGuests,
  adminHostAccess,
  adminReviewSpaces
]
const smartBookBizAdmin: Link[] = [smartBookEvents, smartBookInsights]
const leadFeedSubNav: Link[] = [
  leadFeed,
  leadFeedInterestedGuests,
  leadFeedSentMessages,
  leadFeedInsights,
  leadFeedTemplates,
  leadFeedPreferences
]
const smartBookHostSubav: Link[] = [smartBookResponseOpportunities, smartBookResponseBookings, smartBookResponseArchive]

const subNav: Record<string, Partial<Record<ActorRoles, Link[]>>> = {
  [HEADER_DEMO_LINK]: {
    [ActorRoles.ADMIN]: [...adminSubNav, redBoxAdmin],
    [ActorRoles.ACCOUNT_MANAGER]: adminSubNav,
    [ActorRoles.REGIONAL_MANAGER]: adminSubNav,
    [ActorRoles.LEAD_FEED_HOST]: leadFeedSubNav,
    [ActorRoles.SMART_BOOK_HOST]: smartBookHostSubav,
    [ActorRoles.BIZ_ADMIN]: smartBookBizAdmin,
    [ActorRoles.BIZ_MANAGER]: [smartBookEvents],
    [ActorRoles.BIZ_MEMBER]: [smartBookEvents]
  },
  [HOST_ADMIN_LINK]: {
    [ActorRoles.ADMIN]: [...adminSubNav, redBoxAdmin],
    [ActorRoles.ACCOUNT_MANAGER]: adminSubNav,
    [ActorRoles.REGIONAL_MANAGER]: adminSubNav
  },
  [HOST_LEADS_LINK]: {
    [ActorRoles.ADMIN]: leadFeedSubNav,
    [ActorRoles.ACCOUNT_MANAGER]: leadFeedSubNav,
    [ActorRoles.REGIONAL_MANAGER]: leadFeedSubNav,
    [ActorRoles.LEAD_FEED_HOST]: leadFeedSubNav,
    [ActorRoles.SMART_BOOK_HOST]: leadFeedSubNav
  },
  [SMART_BOOK_RESPONSE_LINK]: {
    [ActorRoles.SMART_BOOK_HOST]: smartBookHostSubav
  },
  [SMART_BOOK_EVENTS_LINK]: {
    [ActorRoles.BIZ_ADMIN]: smartBookBizAdmin,
    [ActorRoles.BIZ_MANAGER]: [smartBookEvents],
    [ActorRoles.BIZ_MEMBER]: [smartBookEvents]
  },
  [SMART_BOOK_INSIGHTS_LINK]: {
    [ActorRoles.BIZ_ADMIN]: smartBookBizAdmin
  }
}

export const useSubNav = (): Link[] | null => {
  const [withoutNav] = useGlobalState('withoutNav')
  const location = subNavLocations.find((href) => window.location.href.includes(href))
  const [{ role }] = useGlobalState('session')

  if (withoutNav || location === undefined || role === undefined || subNav[location][role] === undefined) {
    return null
  }

  return subNav[location][role]
}
